import { render, staticRenderFns } from "./TodoListing.vue?vue&type=template&id=08a1063a"
import script from "./TodoListing.vue?vue&type=script&lang=js"
export * from "./TodoListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports